import * as React from 'react';
import { assets } from '../../../assets';
import LegalInformation from '../../ui-utils/legal-information';
import CustomMenu from './custom-menu';
import ProfileMenu from './profile-menu';
import ErrorBoundary from '../../utils/error-boundary';
import config from '../../../../config';

const MenuSidebar = (): JSX.Element => (
  <div className="sidebar-left flex-none">
    <ErrorBoundary>
      <CustomMenu />
      <div className="w-1/1">
        <ProfileMenu />
        <div className="flex flex-row">
          <img className="dnet-icon-small" src={assets.icons.tradebull_logo} alt="TradeBull icon" />
          <p className="login-instructions" style={{ margin: 10 }}>
            {config.version}
          </p>
        </div>

        <div className="sidebar-legal-wrapper">
          <LegalInformation />
        </div>
      </div>
    </ErrorBoundary>
  </div>
);

export default MenuSidebar;
